import React from 'react';

function DeleteUserData (props) {   
          return(
                    <div>
                        <div className="text">
                            <button className="btn"  onClick={()=>props.toggle()}>
                                        No
                            </button>
                            <button className="danger-button" onClick={()=>props.deleteUser()}>
                                        Yes
                            </button>
                        </div>
                    </div>
          )
}
export default DeleteUserData;